// @ts-nocheck
/* eslint-enable */
// App
import React, { useEffect, useRef } from 'react';
import FocusLock from 'react-focus-lock';

// Misc / utils
import * as S from './styles';

const CommuteButtonDropdown = ({
  ariaLabel,
  buttonRef,
  currentButtonValue,
  dropDownItemRefList,
  dropDownItemClick,
  dropDownItemKeyDown,
  isButtonDisabled,
  labelId,
  onButtonClick,
  onButtonKeyDown,
  options,
  showDropdown,
}) => {
  const isLoaded = useRef(null);
  useEffect(() => {
    /**
     * isLoaded is a component instance variable. Do not set focus on the button until
     * after the component has been interacted with.
     * @see: https://reactjs.org/docs/hooks-faq.html#is-there-something-like-instance-variables
     */
    if (!isLoaded.current) {
      isLoaded.current = true;
    } else {
      if (!showDropdown) {
        buttonRef.current.focus();
      }
    }
  }, [currentButtonValue]);

  return (
    <FocusLock disabled={!showDropdown}>
      <S.DropdownButton
        aria-label={ariaLabel}
        aria-disabled={isButtonDisabled}
        aria-expanded={showDropdown}
        disabled={isButtonDisabled}
        id={labelId}
        onClick={onButtonClick}
        onKeyDown={onButtonKeyDown}
        ref={buttonRef}
        showCarat
      >
        {currentButtonValue}
      </S.DropdownButton>
      {showDropdown && (
        <S.DropdownList>
          {options.map((option, idx) => {
            return (
              <S.DropdownListItem
                aria-selected={option === currentButtonValue}
                tabIndex={idx}
                data-option-value={option}
                onKeyDown={dropDownItemKeyDown}
                onClick={dropDownItemClick}
                ref={dropDownItemRefList[idx]}
                role="option"
                key={`dropdown-option-${option}-${idx}`}
              >
                {option}
              </S.DropdownListItem>
            );
          })}
        </S.DropdownList>
      )}
    </FocusLock>
  );
};

export default CommuteButtonDropdown;
